// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"d2e780cf","252":"f092f2aa"}[chunkId] + ".chunk.js";
};